import { Tag, Tooltip } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";

interface ConversionStatusCellProps {
    status: string | null;
    message?: string | null;
}

type StatusVariant = "green" | "default" | "orange" | "red";

export const CONVERSION_STATUS_VALUES = [
    "sold",
    "redirected",
    "new",
    "verification",
    "in_bid",
    "cascade",
    "invalid_data",
    "refused_by_validation",
    "refused_by_filter",
    "refused_by_cascade",
    "duplicate_advertiser",
    "error",
    "no_active_channel_found",
    "no_cascade",
    "no_offer_link_found",
    "endpoint_not_allowed",
] as const;

export const LEAD_STATUS_VALUES = CONVERSION_STATUS_VALUES.filter(
    (s) => !["sold", "redirected", "duplicate_advertiser"].includes(s)
);

export const CLICK_STATUS_VALUES = CONVERSION_STATUS_VALUES.filter(
    (s) => !["cascade", "refused_by_cascade", "no_cascade"].includes(s)
);

const STATUS_VARIANTS: Record<string, StatusVariant> = {
    sold: "green",
    redirected: "green",
    new: "default",
    verification: "default",
    in_bid: "default",
    cascade: "default",
    invalid_data: "orange",
    refused_by_validation: "orange",
    refused_by_filter: "orange",
    refused_by_cascade: "orange",
    duplicate_advertiser: "orange",
    error: "red",
    no_active_channel_found: "red",
    no_cascade: "red",
    no_offer_link_found: "red",
    endpoint_not_allowed: "red",
};

export const ConversionStatusCell = ({ status, message }: ConversionStatusCellProps) => {
    const { t: tGeneral } = usePaldockTranslation("general");

    if (!status) {
        return <>-</>;
    }

    const translationKey = `conversion_state_status.${status}`;
    const label = tGeneral(translationKey);
    const variant: StatusVariant = STATUS_VARIANTS[status] ?? "default";

    const tag = <Tag color={variant}>{label !== translationKey ? label : status}</Tag>;

    return message ? (
        <Tooltip title={message} color="black">
            {tag}
        </Tooltip>
    ) : (
        tag
    );
};
